import { render } from "./EditPKSModal.vue?vue&type=template&id=37e865b8&scoped=true"
import script from "./EditPKSModal.vue?vue&type=script&lang=js"
export * from "./EditPKSModal.vue?vue&type=script&lang=js"

import "./EditPKSModal.vue?vue&type=style&index=0&id=37e865b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e865b8"]])

export default __exports__